import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { Table, Button, Input } from "antd";
import columns from "./columns"; // Uses attribute_id, attribute_name, attribute_key
import FullPageLoader from "../common/FullPageLoader";
import ErrorNotification from "../common/ErrorNotification";
import apiHelpers from "./data";
import AttributeDrawer from "./AttributeDrawer";
import CreateDrawer from "./CreateDrawer";
import { useAuth } from "../UserAuth/AuthContext";

const { Search } = Input;
const AttributesTable = ({ globalList, setGlobalList }) => {
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const tableWrapperRef = useRef(null);
  const [isloader, setisloader] = useState(true);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [createDrawerVisible, setCreateDrawerVisible] = useState(false);
  const [selectedDrawerdata, setSelectedDrawerdata] = useState({});
  const [originalData, setOriginalData] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [stickyHeader, setStickyHeader] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const { userData } = useAuth();
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      if (tableWrapperRef.current) {
        const scrollTop = tableWrapperRef.current.scrollTop;
        setStickyHeader(scrollTop > 0); // enable sticky only when scrolling starts
      }
    };

    const wrapper = tableWrapperRef.current;
    if (wrapper) {
      wrapper.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (wrapper) {
        wrapper.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const fetchData = async (attribute_name = "") => {
    const response = await apiHelpers.apidata(); // response = mappedData
    if (response) {
      setGlobalList({ ...globalList, attributes_tab_datalist: response })
      setOriginalData(response);
      if (searchValue) {
        const filtered = response.filter((item) =>
          Object.values(item)
            .join(" ")
            .toLowerCase()
            .includes(searchValue.toLowerCase())
        );
        setData(filtered);
      } else {
        setData(response);
      }
      setisloader(false);
    }

    if (attribute_name != "") {
      const isExist = response.find(item => item.attribute_name === attribute_name)


      if (isExist) {
        openDrawer(isExist.key, response)
      }
    }
  };
  useEffect(() => {
    if (!globalList || !globalList.attributes_tab_datalist || globalList.attributes_tab_datalist.length <= 0) {
      fetchData();
    }
  }, []);
  useEffect(() => {
    if (globalList && globalList.attributes_tab_datalist) {
      setOriginalData(globalList.attributes_tab_datalist);
      setisloader(false);
    }
  }, [globalList]);

  useEffect(() => {
    if (searchValue) {
      const filtered = originalData.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      );
      setData(filtered);
    } else {
      setData(originalData);
    }
  }, [searchValue, originalData]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    const filtered = originalData.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(value.toLowerCase())
    );
    setData(filtered);
  };

  const updatedColumns = useMemo(() => {
    return columns
      .filter((col) => col.dataIndex)
      .map((col) => {
        if (col.dataIndex === "attribute_name") {
          return {
            ...col,
            render: (_, record) => (
              <Button type="link" onClick={e => openDrawer(record.key)}>
                {record.attribute_name}
              </Button>
            )
          };
        }
        return col;
      });
  });

  const openDrawer = useCallback((key, Opendata = data) => {

    const selected = Opendata.find(item => item.key === key);

    if (selected) {
      setSelectedDrawerdata({
        id: selected.attribute_id,
        attribute_name: selected.attribute_name,
        attribute_key: selected.attribute_key,
        max_size: selected.max_size,
        values_data: selected.values_data,
        attribute_element_type: selected.attribute_element_type,
        attri_pattern: selected.attri_pattern,
        attribute_label: selected.attribute_label
      });
      setDrawerVisible(true);
    }
  }, [data]);
  const closeDrawer = () => setDrawerVisible(false);

  const CreateProductOpenDrawer = () => {
    setCreateDrawerVisible(true)
  };
  const CreateCloseDrawer = () => setCreateDrawerVisible(false);
  return (
    <>
      <div style={{ marginBottom: 16 }} className="TableFilterBox">
        {userData?.data?.access === "ALL" && (
          <Button type="primary" onClick={CreateProductOpenDrawer}>
            Create New Attribute
          </Button>
        )}
        <Search
          placeholder="Search"
          style={{ width: 280 }}
          allowClear
          enterButton
          value={searchValue}
          onChange={handleSearch}
        />
      </div>
      <div
        className="TableBox"
        ref={tableWrapperRef}
        style={{ maxHeight: 700, overflow: 'auto' }}
      >
        <Table
          // rowSelection={rowSelection}
          columns={updatedColumns}
          dataSource={data} // This is mappedData
          pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: data.length,
            onChange: (page, pageSize) => {
              setCurrentPage(page);
              setPageSize(pageSize);
            },
            showTotal: (total) =>
              `Total ${total} items${selectedRowKeys.length > 0 ? ` | Selected: ${selectedRowKeys.length}` : ''}`,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50', '100'],
            position: ['bottomLeft'],
          }}
          bordered
          scroll={{ x: '100%', y: 500 }}
          sticky={stickyHeader ? { offsetHeader: 0 } : false}
        />

        <FullPageLoader isloader={isloader} />
        <ErrorNotification {...alert} />
      </div>
      {drawerVisible && <AttributeDrawer attrdata={selectedDrawerdata} onProductCreate={fetchData} visible={drawerVisible} onClose={closeDrawer} setisloader={setisloader} />}
      {createDrawerVisible && <CreateDrawer attrdata={selectedDrawerdata} onProductCreate={fetchData} visible={createDrawerVisible} onClose={CreateCloseDrawer} setisloader={setisloader} attributesList={globalList?.attributes_tab_datalist || []} />}
    </>
  );
};

export default AttributesTable;
